import React from 'react';
import PropTypes from 'prop-types';

const Close = ({
	fill = '#4a4a4a',
	...props
}) =>
	<svg width="9" height="9" viewBox="0 0 9 9" fill={fill} {...props}>
		<path d="M3.5,2.08578644 L6.29289322,-0.707106781 C6.68341751,-1.09763107 7.31658249,-1.09763107 7.70710678,-0.707106781 C8.09763107,-0.316582489 8.09763107,0.316582489 7.70710678,0.707106781 L4.91421356,3.5 L7.70710678,6.29289322 C8.09763107,6.68341751 8.09763107,7.31658249 7.70710678,7.70710678 C7.31658249,8.09763107 6.68341751,8.09763107 6.29289322,7.70710678 L3.5,4.91421356 L0.707106781,7.70710678 C0.316582489,8.09763107 -0.316582489,8.09763107 -0.707106781,7.70710678 C-1.09763107,7.31658249 -1.09763107,6.68341751 -0.707106781,6.29289322 L2.08578644,3.5 L-0.707106781,0.707106781 C-1.09763107,0.316582489 -1.09763107,-0.316582489 -0.707106781,-0.707106781 C-0.316582489,-1.09763107 0.316582489,-1.09763107 0.707106781,-0.707106781 L3.5,2.08578644 Z" transform="translate(1 1)"/>
	</svg>;

Close.propTypes = {
	fill: PropTypes.string
};

export default Close;
